import type { ArrCreationPlan } from "@revelate/types/required-pipeline-creation";

// IT Software's existing ARR assumptions. Never persisted or passed to Forecast.
function itSoftwareArrPlan(): ArrCreationPlan {
  return {
    kind: "arr", startMonth: "2026-10", targetMonth: "2029-12", startingArr: 30_000_000,
    targetArr: 100_000_000, annualRetention: 0.9, monthlyExpansionArr: 0,
    money: { currency: "SEK", unit: "annualized-recurring-revenue" }, confirmation: "provisional",
  };
}

export function provisionalCreationPlan(companyId: number | undefined): ArrCreationPlan | null {
  return companyId === 53 ? itSoftwareArrPlan() : null;
}

export function currentCreationPlan(companyId: number | undefined): ArrCreationPlan | null {
  const plan = provisionalCreationPlan(companyId);
  // Emil adopted this as the operating plan on 2026-10-28. A later review with
  // Stefan does not gate today's assessment. No numeric assumptions are changed.
  return plan ? { ...plan, confirmation: "confirmed" } : null;
}
